module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921021149_T.4c1c7595.jpg";